<template lang="pug">
div.fill-height
  v-card.round-xl.fill-height(outlined)
    .treatment-filters
      v-progress-linear(v-if="isFetchingInvoice || isFetchingActiveMeds" :width="3" rounded color="primary" indeterminate)
      v-tabs.px-4.py-2(v-model="tabs" height="36" hide-slider active-class="active-selected-tab")
        v-tab(style="min-width: unset; padding: 10px;")
          div.text-sm.normal-case All
            span.font-medium.custom-chip.neutral100--text(:style="`background-color: ${!tabs ? 'var(--v-neutral500)' : 'var(--v-neutral400)'}`") {{ treatments.length }}
        v-tab(style="min-width: unset; padding: 10px;")
          div.text-sm.normal-case Items
            span.font-medium.custom-chip.neutral100--text(:style="`background-color: ${tabs === 1 ? 'var(--v-neutral500)' : 'var(--v-neutral400)'}`") {{ itemList.length }}
        v-tab(style="min-width: unset; padding: 10px;")
          div.text-sm.normal-case Services
            span.font-medium.custom-chip.neutral100--text(:style="`background-color: ${tabs === 2 ? 'var(--v-neutral500)' : 'var(--v-neutral400)'}`") {{ serviceList.length }}
        v-tab(style="min-width: unset; padding: 10px;")
          div.text-sm.normal-case Packages
            span.font-medium.custom-chip.neutral100--text(:style="`background-color: ${tabs === 3 ? 'var(--v-neutral500)' : 'var(--v-neutral400)'}`") {{ packageList.length }}
        v-tab(style="min-width: unset; padding: 10px;")
          div.text-sm.normal-case Documents
            span.font-medium.custom-chip.neutral100--text(:style="`background-color: ${tabs === 4 ? 'var(--v-neutral500)' : 'var(--v-neutral400)'}`") {{ documentList.length }}
        //- v-tabs-slider(style="width: 40px; place-self: center")
      v-divider
      div.d-flex.align-center.px-4.py-2
        y-button(label="Print all labels" :disabled="isPrintAllLabelsDisabled" :loading="isLoadingLabels" outlined color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" prepend-icon="$yzi-tag-02" icon-size="16" icon-color="neutral500" unset-min-width size="xxs" button-class="px-2" @click="printAllLabels")
        y-button.ml-3(label="Print all documents" :disabled="isPrintAllDocumentsDisabled" :loading="isLoadingDocuments" outlined color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" prepend-icon="$yzi-file-05" icon-size="16" icon-color="neutral500" unset-min-width size="xxs" button-class="px-2" @click="printAllDocumentss")
        v-spacer
        y-button(label="Edit" outlined color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" button-class="px-2" @click="openTreatmentPlanDialog")
      v-divider

    template(v-if="isFetchingInvoice || isFetchingActiveMeds")
      v-skeleton-loader.px-4(type="list-item-three-line@3")
    template(v-else-if="treatmentList.length === 0")
      div.d-flex.align-center.justify-center.fill-height(style="min-height: 200px;")
        div(align="center")
          v-icon(size="32" color="neutral500") $yzi-file-02
          div.text-sm.font-medium.neutral700--text.mt-2 No treatment and services selected yet
          div.text-sm.neutral500--text.mt-1 Start adding treatment to see treatment plan here
          y-button.mt-2(label="Add treatment" color="neutral300" text-color="neutral700" prepend-icon="mdi-plus" icon-size="16" icon-color="neutral500" unset-min-width size="xs" button-class="px-2" @click="showTreatmentPlanDialog = true")
    template(v-else)
      div.pb-3
        div.parent-scroll(:style="{ '--page-height': pageHeight }")
          div.child-scroll(:style="{ '--page-height': pageHeight, '--nve-right-margin': nveRightMargin }")
            template(v-for="(treatment, idx) in treatmentList")
              v-divider(v-if="idx")
              treatment-item(:treatment="treatment" :item-index="idx" :key="`tr-${idx}`" @updated="updateTreatments")

  .dialogs
    treatment-plan-dialog(v-if="showTreatmentPlanDialog" :open.sync="showTreatmentPlanDialog" :edit-mode="true" :isOTC="isOTC" @closed="closed" @updated="updateTreatments")

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import TreatmentItem from '@/components/clinic/checkout/TreatmentItem.vue'
import TreatmentPlanDialog from '@/components/clinic/consultation/TreatmentPlanDialog.vue'

export default {
  components: { TreatmentItem, TreatmentPlanDialog },
  data() {
    return {
      isFetchingInvoice: false,
      isFetchingActiveMeds: false,
      isLoadingLabels: false,
      isLoadingDocuments: false,
      showTreatmentPlanDialog: false,
      selectedTreatment: null,
      tabs: 0,
    }
  },
  props: {},
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      company: 'getCompany',
      leadPid: 'treatment/getLeadPid',
      patient: 'treatment/getPatient',
      treatments: 'treatment/getTreatments',
      registration: 'treatment/getRegistration',
      displaySize: 'ui/getDisplaySize',
      scrollbarWidth: 'ui/getScrollbarWidth',
      hqSelectedCompany: 'hq/getSelectedCompany',
      isHq: 'hq/getIsHq'
    }),
    isOTC () {
      // For migrated data, otc is false
      if (!this.registration) return false

      return this.registration?.code === 3
    },
    treatmentList () {
      if (this.tabs === 1) return this.itemList
      if (this.tabs === 2) return this.serviceList
      if (this.tabs === 3) return this.packageList
      if (this.tabs === 4) return this.documentList
      else return this.treatments
    },
    itemList () {
      return this.treatments.filter(f => ['medication', 'equipment', 'consumable'].includes(f.product.type))
    },
    serviceList () {
      return this.treatments.filter(f => ['service', 'procedure', 'investigation', 'consultation'].includes(f.product.type))
    },
    packageList () {
      return this.treatments.filter(f => ['bundle'].includes(f.product.type))
    },
    documentList () {
      return this.treatments.filter(f => ['documents'].includes(f.product.type))
    },
    allMedicationItems () {
      return this.treatments.filter(item => item.product.medication || item.bundles.filter(bundle => bundle.product.medication).length)
    },
    isPrintAllLabelsDisabled () {
      return this.allMedicationItems.length === 0
    },
    isPrintAllDocumentsDisabled () {
      return this.documentList.length === 0
    },
    screenHeight () {
      return window.innerHeight
    },
    pageHeight () {
      let minusHeight = 279
      switch (this.displaySize) {
        case 'xx-small':
          return `${(this.screenHeight / 0.67) - minusHeight}px`
        case 'x-small':
          return `${(this.screenHeight / 0.75) - minusHeight}px`
        case 'small':
          return `${(this.screenHeight / 0.8) - minusHeight}px`
        case 'medium':
          return `${(this.screenHeight / 0.9) - minusHeight}px`
        case 'large':
          return `${(this.screenHeight) - minusHeight}px`
        case 'x-large':
          return `${(this.screenHeight / 1.1) - minusHeight}px`
        default:
          return `${(this.screenHeight) - minusHeight}px`
      }
    },
    nveRightMargin () {
      return `${(-10 - this.scrollbarWidth)}px`
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchInvoice () {
      this.isFetchingInvoice = true
      this.$axios.get(`/invoices/${this.leadPid}`)
        .then(resp => {
          this.$store.commit('treatment/setInvoice', resp.data)
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingInvoice = false
        })
    },
    fetchActiveMedication () {
      this.isFetchingActiveMeds = true
      const params = {
        page_size: -1,
        patient: this.patient.id,
        expand: 'medication'
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      this.$axios.get(`/clinics/${companySlug}/active_medications`, { params })
        .then(resp => {
          let activeMedications = []
          if (resp.data && resp.data.results) {
            activeMedications = resp.data.results.map(m => { return { id: m.id, m_id: m.medication.id, name: m.medication.name } })
          }
          this.$store.commit('treatment/setActiveMedications', activeMedications)
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingActiveMeds = false
        })
    },
    updateTreatments () {
      this.fetchInvoice()
      this.fetchActiveMedication()
      this.closed()
    },
    async printAllLabels () {
      if (this.allMedicationItems.length === 0) {
        this.showMessage(['error', 'No medication label'])
        return
      }
      // Download process
      this.isLoadingLabels = true
      // Get key first
      let key
      try {
        const { data } = await this.$axios.post(`users/${this.user.id}/request_otk`)
        key = data.key
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        this.isLoadingLabels = false
        return
      }
      // Open download url
      let baseUrl = process.env.VUE_APP_BASE_URL
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        baseUrl = 'https://api-test.yezza.io'
      } else if (process.env.VUE_APP_ENV === 'prod') {
        baseUrl = 'https://export.yezza.io'
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      const url = `${baseUrl}/clinics/${companySlug}/registrations/${this.leadPid}/preview_medication_labels?key=${key}`
      window.open(url, '_blank')
      this.isLoadingLabels = false
    },
    async printAllDocumentss () {
      if (this.allMedicationItems.length === 0) {
        this.showMessage(['error', 'No medication label'])
        return
      }
      // Download process
      this.isLoadingDocuments = true
      // Get key first
      let key
      try {
        const { data } = await this.$axios.post(`users/${this.user.id}/request_otk`)
        key = data.key
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        this.isLoadingDocuments = false
        return
      }
      // Open download url
      let baseUrl = process.env.VUE_APP_BASE_URL
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        baseUrl = 'https://api-test.yezza.io'
      } else if (process.env.VUE_APP_ENV === 'prod') {
        baseUrl = 'https://export.yezza.io'
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      const url = `${baseUrl}/clinics/${companySlug}/registrations/${this.leadPid}/preview_medical_documents?key=${key}`
      window.open(url, '_blank')
      this.isLoadingDocuments = false
    },
    openTreatmentPlanDialog () {
      this.showTreatmentPlanDialog = true
    },
    closed () {
      this.selectedTreatment = null
      this.showTreatmentPlanDialog = false
    }
  },
};
</script>

<style lang="scss" scoped>
.selected-button {
  background: #EEEEEE !important;
  border-radius: 16px;
}
.custom-chip {
  margin-left: 8px;
  padding-right: 5px;
  padding-left: 5px;
  border-radius: 5px;
}
.active-selected-tab {
  background-color: var(--v-neutral300) !important;
  border-radius: 10px;
}
.parent-scroll {
  overflow: hidden;
  max-height: var(--page-height) !important;
}
.child-scroll {
  overflow-y: scroll;
  max-height: var(--page-height) !important;
  margin-right: var(--nve-right-margin);
  padding-right: 10px;
}
</style>